import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';
import { BarChart, CartesianGrid, XAxis, Tooltip, Legend, Bar, ResponsiveContainer, YAxis } from 'recharts';
import { List } from 'material-ui';
import {Table} from 'react-bootstrap';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class InterviewReport extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.pdfStats = this.pdfStats.bind(this);
		this.excelStats = this.excelStats.bind(this);
		this.pdfGraphics = this.pdfGraphics.bind(this);

		this.state = {
			health_facilities_id:"",
			start_date 	: "",
			end_date 	: "",
			format:"",
			listado:[],
			columns:[
				{title:'Fecha/Hra. Ofrecimiento', width:'150px'},
				{title:'No. Ofrecimiento', width:'100px'},
				{title:'Donador', width:'220px'},
				{title:'No. Donación', width:'150px'},
				{title:'Fecha/Hra. Respuesta Cuestionario', width:'220px'},
			],
			filename:"Resultados Encuesta Donantes",
			date_hour:"",
			medical:"",
			total:"",
			tables:[],
			tables_pdf:[],
			graphics:[],
			img_graphics:[],
			colorArray: ['#FF6633', '#FFB399', '#FF33FF','#00B3E6', '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
					title: this.state.filename,
					//pageSize: this.state.format === '''LEGAL',
                	//orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas+'\t\t\t'+this.state.medical, margin:[10,0,0,10] });
					
						doc.content.push(
							{text:'Total: '+this.state.total, margin:[5, 10, 0, 0]}
						)

						doc.content[3].table.widths=["15%","15%","40%","10%","20%"];
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
						doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
						
                	} 
            	},
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: true,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

	}

	async handleChange(e){
		var name = e.target.name;
		var value = e.target.value;
		await this.setState({
			[e.target.name]: e.target.value
		});

		if(name === 'format'){
			if(this.state.format === 'list'){			
				this.setTable();
			}else{
				this.$el = $(this.el);
				
				this.$el.DataTable().destroy();
				this.$el.empty();
			}
		}
		
		var control = document.getElementById(name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

	}

	searching(){		
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					health_facilities_id: this.state.health_facilities_id,
					format:this.state.format
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/survey_report',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var columns = [];
						var list = [];
						var pdf = [];

						if(this.state.format === 'list'){
							columns = [
								{title:'Fecha/Hra. Ofrecimiento', width:'150px'},
								{title:'No. Ofrecimiento', width:'100px'},
								{title:'Donador', width:'220px'},
								{title:'No. Donación', width:'150px'},
								{title:'Fecha/Hra. Respuesta Cuestionario', width:'220px'},
							];
							response.list.map((resp, i)=>{
								var obj = [
									moment(resp.offer_date).format('DD/MM/YYYY')+' '+moment(resp.offer_hour, 'HH:mm:ss.sssssss').format('HH:mm:ss'),
									resp.offer_id,
									resp.donor_name,
									resp.donation_number,
									moment(resp.timestamp_questionnaire).format('DD/MM/YYYY HH:mm:ss')
								];
	
								return list.push(obj);	
							});

							setTimeout(()=>{
								this.props.waiting.handleShow('Cargando...');
								this.$el = $(this.el);
								this.$el.DataTable().destroy();
								this.$el.empty();
							}, 500);
	
							setTimeout(()=>{
								this.props.waiting.handleClose();
								this.setTable();
							}, 1000);
	
							this.setState({
								listado: list,
								//columns: columns,
								total: response.total
							});
						}else if(this.state.format === 'stats'){							
							response.forEach((res)=>{
								var columns = [{title:res.label}];
								res.options.forEach((option)=>{
									columns.push({title:option.label, key:option.key});
								});
								columns.push({title:'TOTAL'})
								
								var answers = [];
								res.blocks.forEach((block)=>{
									var obj = [block.label === "" ? "TOTALES" : block.label];

									columns.forEach((col)=>{
										if(col.key !== undefined){
											var index = block.answers.findIndex(item => item.key === col.key);

											if(index !== -1){
												obj.push(block.answers[index].total);
											}else{
												obj.push(0);
											}
										}
									});

									if(block.label === ""){
										obj.push(res.total)
									}else{
										obj.push(block.total)
									}
									

									answers.push(obj);
								});
								

								list.push({columns:columns, answers:answers});
							});

							this.setState({tables: list});
						}else if(this.state.format === 'graphics'){
							var graphics = [];

							response.forEach(res => {
								var obj = {
									title: res.description,
									graphic:[],
									columns:[],
									answers:[]
								};

								
								res.blocks.forEach(block => {
									var item = {name: block.label};
									var columns = [];
									var list = [block.label];

									block.answers.forEach((answer, i) => {																				
										var index = res.options.findIndex(aux => aux.key === answer.key);

										item[res.options[index].label] = answer.total;
										columns.push({title:res.options[index].label, key:res.options[index].label, color:this.state.colorArray[i]})
										list.push(answer.total);
									});

									obj.graphic.push(item);
									obj.columns = columns;
									obj.answers.push(list);

								});

								if(res.blocks.length === 0){
									
									res.options.forEach((option, i) => {
										var item = {name: option.label};									

										item[option.label] = option.total;

										columns.push({title:option.label, key:option.label, color:this.state.colorArray[i]})
										list.push(option.total);

										obj.graphic.push(item);
										
									})
									obj.columns = columns;
									obj.answers.push(list);
								}

								graphics.push(obj);

							})

							this.setState({graphics: graphics, img_graphics:[]});
						}

						

						
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if (this.state.type == 'fecha'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	pdfStats(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		
		var doc = {
			content:[
				{
					image: this.props.header_document,
					alignment:'center',
					width:this.props.w_head
				},
				{
					text:this.state.filename, style:'title', margin:[0,10,0,12],alignment: 'center', fontSize: 15
				},
				{
					text: fechas, margin:[10,0,0,10]
				},				
			],
			defaultStyle:{fontSize:6.5},
			pageMargins:40,
			footer:{text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]},
			pageOrientation:'portrait',
			pageSize:'A4',
			styles:{
				tableBodyEven:{},
				tableBodyOdd:{fillColor:'#f3f3f3'},
				tableHeader:{bold:true, fontSize:6.5, color:'white', fillColor:'#2d4154', alignment:'center'}
			}

		};
		
		this.state.tables.forEach((table)=>{
			var content = {
				layout:'noBorders',
				table:{
					body:[],
					headerRows:1,
					widths:[]
				}
			};
			var body = [];

			table.columns.forEach((col)=>{
				body.push({text:col.title, style:'tableHeader', fillColor:'#2d4154'});
			});

			content.table.body.push(body);

			var widths = [];
			var w = 0;
			
			if(table.columns.length > 3){
				widths = ['40%'];
				var w = 60 / (table.columns.length - 1);	
			}else{
				widths = ['55%'];
				var w = 45 / (table.columns.length - 1);
			}

			

			for(var i = 1; i < table.columns.length; i++){
				widths.push(w+'%');
			}

			content.table.widths = widths;
			
			table.answers.forEach((answer, i)=>{
				body = [];
				answer.forEach((ans)=>{
					body.push({text:ans, style:((i+1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven'});
				});

				content.table.body.push(body);
				
			})

			doc.content.push(content, {text:"", margin:[0,10,0,10]})
			
		});
	
		pdfMake.createPdf(doc).download(this.state.filename+'.pdf');
		
	}

	excelStats(){
		var obj = {
			start_date:this.state.start_date,
			end_date:this.state.end_date,
			health_facilities_id: this.state.health_facilities_id,
			format:this.state.format
		};

		this.props.waiting.handleShow('Generando...');
		fetch(Config.default.apiGateway.URL+'reports/generate_excel?report_name=survey_report',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob', 
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(msg => {
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var blob = new Blob([response], {type: 'application/vnd.ms-excel'});
				var downloadUrl = URL.createObjectURL(blob);
				var a = document.createElement("a");
				a.href = downloadUrl;
				a.download = this.state.filename+'.xlsx';
				document.body.appendChild(a);
				a.click();
			}
		})
	}

	pdfGraphics(e){
		e.preventDefault();

		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		
		var doc = {
			content:[
				{
					image: this.props.header_document,
					alignment:'center',
					width:this.props.w_head
				},
				{
					text:this.state.filename, style:'title', margin:[0,10,0,12], alignment: 'center', fontSize: 15
				},
				{
					text: fechas, margin:[10,0,0,10]
				},				
			],
			defaultStyle:{fontSize:6.5},
			pageMargins:40,
			footer:{text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]},
			pageOrientation:'portrait',
			pageSize:'A4',
			styles:{
				tableBodyEven:{},
				tableBodyOdd:{fillColor:'#f3f3f3'},
				tableHeader:{bold:true, fontSize:6.5, color:'white', fillColor:'#2d4154', alignment:'center'}
			}

		};

		this.state.img_graphics.forEach((img, i)=>{
			var graphic = this.state.graphics[i];

			var image = {
				image: img,
				alignment:'center',
				width:500
			};

			doc.content.push(
				{text:graphic.title, alignment:'center', fontSize:8, margin:[0,5,0,5]},
				image, 
				{text:"", margin:[0,10,0,10]}
			);

			var content = {
				layout:'noBorders',
				table:{
					body:[],
					headerRows:1,
					widths:[]
				}
			};

			
			var body = [];

			if(graphic.answers.length > 2){				
				body  = [{text:'', style:'tableHeader', fillColor:'#2d4154'}]
			}
			graphic.columns.forEach(col => {
				body.push({text:'', width:10, height:10, fillColor:col.color});
				body.push({text:col.title, style:'tableHeader'});
			})

			content.table.body.push(body);

			var widths = [];
			var w = 0;
			if(graphic.answers.length === 1){
				widths = ['2%','48%','2%','48%'];
			}else{
				if(graphic.columns.length > 2){
					widths = ['40%'];
					var w = 60 / (graphic.columns.length);

					for(var i = 0; i < graphic.columns.length; i++){
						widths.push('2%');
						widths.push((w-2)+'%');
					}
				}else{
					widths = ['40%', '2%', '28%', '2%', '28%'];
				}
			}

			content.table.widths = widths;

			graphic.answers.forEach((answer, i)=>{
				body = [];
				answer.forEach((ans, j)=>{
					if(answer.length === 2 && j === 0){
						body.push({text:'', style:((i+1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven'});
					}
					if(j > 0){
						body.push({text:'', style:((i+1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven'});
					}
					body.push({
						text:ans, 
						style:((i+1) % 2) === 0 ? 'tableBodyOdd' : 'tableBodyEven', 
						alignment:ans.length > 2 ? j>0 ? 'center' : '' : 'center'
					});
				});

				content.table.body.push(body);
				
			})


			doc.content.push(content, {text:"", margin:[0,10,0,10]})

		})

		pdfMake.createPdf(doc).download(this.state.filename+'.pdf');
		
	}

	svgToPng(svg, width, height){

		return new Promise((resolve, reject) => {
	
			let canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;
			let ctx = canvas.getContext('2d');
	
			// Set background to white
			ctx.fillStyle = '#ffffff';
			ctx.fillRect(0, 0, width, height);
	
			let xml = new XMLSerializer().serializeToString(svg);
			let dataUrl = 'data:image/svg+xml;utf8,' + encodeURIComponent(xml);
			let img = new Image(width, height);
	
			img.onload = () => {
				ctx.drawImage(img, 0, 0);
				let imageData = canvas.toDataURL('image/png', 1.0);
				resolve(imageData)
			}
	
			img.onerror = () => reject();
	
			img.src = dataUrl;
		});
	}

	async convertChart(ref){
		var imgs = this.state.img_graphics;
        if (ref && ref.container) {
            let svg = ref.container.children[0];
			let pngData = await this.svgToPng(svg, $('.area-report').width()-50, 300);
			
			imgs.push(pngData);
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_donors"} 
	                submenu={"help_survey_report"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>								
                                <div className="col-xs-12 form-group">
                                    <span className="span-min">Fecha Desde</span>
                                    <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                        value={this.state.start_date} onChange={this.handleChange} required />
                                </div>
                                <div className="col-xs-12 form-group">
                                    <span className="span-min">Fecha Hasta</span>
                                    <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                        value={this.state.end_date} onChange={this.handleChange} required />
                                </div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Formato</span>
									<select className="form-control" name="format" id="format" value={this.state.format}
										onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="list">Listado</option>
										<option value="stats">Estadístico</option>
										<option value="graphics">Gráficas</option>
									</select>
								</div>
								
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10 area-report">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>


								{(this.state.format === 'list' ) &&
									<div>
										<div className="col-xs-12 form-group" id="table-to-pdf">
											<div className="table-responsive">
												<table style={{fontSize:"11px"}} className={'expenses-discards'} id="table-to-xls" width="100%" ref={el => this.el = el}>
												</table>
											</div>
										</div>
										<div className="col-xs-12">
											<label>Total:</label> <span>{this.state.total}</span>
										</div>
									</div>
								}

								{this.state.format === 'stats' ?
									<div>
										
										{this.state.tables.length > 0 &&
											<div className="dt-buttons" style={{float:'right'}}> 
												<button className="dt-button buttons-excel buttons-html5" tabIndex="0" aria-controls="table-to-xls" type="button" onClick={()=>this.excelStats()}>
													<span>Excel</span>
												</button> 
												<button className="dt-button buttons-pdf buttons-html5" tabIndex="0" aria-controls="table-to-xls" type="button" onClick={()=>this.pdfStats()}>
													<span>PDF</span>
												</button> 
											</div>
										}
										
										{this.state.tables.map((table, i)=>
											<div className="col-xs-12 form-group" key={i}>
												<table className="table table-responsive table-hover">
													<thead>
														<tr>
															{table.columns.map((col, c)=>
																<th key={c} style={{textAlign:c > 0 ? 'center' : ''}}>{col.title}</th>
															)}
														</tr>
													</thead>
													<tbody>
														{table.answers.map((answers, a)=>
															<tr key={a}>
																{answers.map((answer, i)=>
																	<td key={i} style={
																		{
																			textAlign: i > 0 ? 'center' : ''
																		}
																	}>{answer}</td>
																)}
															</tr>
														)}
													</tbody>
												</table>
											</div>
										)}
									</div>
								: null}
								
								{this.state.graphics.length > 0 &&
									<div className="dt-buttons" style={{float:'right'}}> 
										<button className="dt-button buttons-pdf buttons-html5" tabIndex="0" aria-controls="table-to-xls" type="button"
											onClick={(e)=>this.pdfGraphics(e)}>
											<span>PDF</span>
										</button> 
									</div>
								}
								{this.state.format === 'graphics' &&
									this.state.graphics.map((graphic, i) => 
										<div className="col-xs-12 form-group" key={i} style={{marginBottom:'5%'}}>
											<div className="col-xs-12">
												<h4 style={{textAlign:'center'}}>{graphic.title}</h4>
											</div>
											<div className="col-xs-12" style={{marginBottom:'3%'}}>
												<ResponsiveContainer 
													width={$('.area-report').width()-50} 
													height={300}
												>
													<BarChart
														width={600}
														height={300}
														data={graphic.graphic}
														margin={{
															top: 5,
															right: 5,
															left: 5,
															bottom: 5,
														}}
														
														ref={ref => setTimeout(()=>{this.convertChart(ref)}, 1000)}
														//ref={ref => (this.graphic+i) = ref}
													>																										
														<CartesianGrid strokeDasharray="1 1" />
														<XAxis dataKey="name" hide={true}/>
														<YAxis />
														<Tooltip />
														
														{graphic.columns.map((bar, j)=>
															<Bar key={j} dataKey={bar.key} fill={bar.color} />
														)}
													</BarChart>												
												</ResponsiveContainer>
											</div>
											
											<div className="col-xs-12 form-group">
												<Table responsive hover>
													<thead>
														<tr>
															{graphic.answers.length > 2 &&
																<th></th>
															}
															{graphic.columns.map((col, i)=>
																<th key={i} style={{textAlign:'center'}}>
																	<div style={{background: col.color, width:13, height:13, display:'inline-block', marginRight:8}}></div>
																	{col.title}
																</th>
															)}
														</tr>
													</thead>
													<tbody>
														{graphic.answers.map((ans, i)=>
															<tr key={i}>
																{ans.map((a, j)=>
																	<td key={j} 
																		style={{
																			textAlign: ans.length > 2 ? 
																				j>0 ? 'center' : '' 
																			: 'center'
																		}}
																	>{a}</td>
																)}
															</tr>
														)}
													</tbody>
												</Table>
											</div>
											<hr/>

										</div>
									)
								}
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (InterviewReport);